<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--screenprinting">
            <h1 class="text-center pad-top--xl z-up text-white text-caps">
                Screen Printing Service
            </h1>
            <h5 class="text-center text-white pad-top--large pad-bottom--xl text-caps">
                <router-link to="/contact-us" class="text-white">
                    Get in touch now for a free quote
                </router-link>
            </h5>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac" style="margin-top:-10px">
            <div class="cell small-12 medium-8">
                <p class="pad--large feature-text">
                    Screen Printing is a premium and durable print method in which ink is
                    transferred through a mesh-based screen directly onto the garment providing
                    a high quality and long-lasting finish. Individual colours are printed onto
                    one another to achieve the required effects in the design. If you need your
                    custom t-shirts quickly check out our next day t shirt printing service with
                    no minimum order. Get in touch now!
                </p>
            </div>
            <div class="cell small-12 medium-4">
                <div class="pad--large">
                    <img src="../../../static/images/customisation/sp-bg.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/screen-print-example.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/screen-print-example-2.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/screen-print-example-3.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <span class="image-decoraction">
                    <img width="70px" src="../../../static/images/customisation/time-money.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="80px" src="../../../static/images/customisation/stopwatch.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="60px" src="../../../static/images/customisation/knowledge.png" alt="" />
                </span>
                <h2 class="feature-heading pad-top pad-bottom">Quick - Cost effective - Experts</h2>
                <p class="feature-text">
                    Screen printing can be the perfect way to personalise a piece of clothing with
                    your brand logo and increase your company’s visibility. Our UK based
                    production facility is capable of printing over 150,000 garments per month
                    making Customised Clothing the perfect choice for wholesale bulk t shirt
                    printing. Create Customised Clothing now with our personalised online t-shirt
                    design tool and with our overnight express shipping service you could receive
                    your order the very next day.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/barclays.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/google.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/microsoft.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl pad-top bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bbc.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/british-gas.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bentley.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-left">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    Ideal for larger quantity orders Most suited to artwork containing spot colours
                    Pantone colour matching available Ideal File Formats are .ai, .eps, .pdf –
                    vectored artwork is required Perfect for large and complex designs Not suitable
                    for headwear, accessories, formal shirts, jackets and fleece garments.
                </p>
                <p class="feature-text">
                    <strong>What’s involved:</strong><br />Your artwork is separated into
                    individual colours, each colour of the design will require an individual
                    mesh-based screen to be prepared. E.g. if a design contains the colours black
                    and white, all of the black areas in the design will be transferred onto one
                    screen and all of the white areas will be transferred onto a second screen.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-8 medium-offset-2">
                <div class="video-container">
                    <iframe src="https://www.youtube.com/embed/ADYYot19_cE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    Specialist machinery then transfers the individual colours of the design onto the
                    mesh-based screens.<br />The screens are then prepared for printing, during this
                    process small holes open up in the mesh and allow for the ink to pass through the
                    required areas of the design.<br />The screens are then loaded, aligned and calibrated
                    onto the printing machines and the machine pressure is set – this step ensures
                    that the colours being printed overlap precise.<br />The garments are then loaded in
                    position onto boards which rotate around the print machine. Each rotation results
                    in either a colour being printed or in a short burst of heat being applied to help
                    cure the ink.<br />The ink is passed through the mesh-based screen using a squeegee at
                    a pre-set pressure. Once the garments have completed a full rotation of the
                    machine they are unloaded and passed through a conveyor drying tunnel, this
                    completely cures any wet ink and completes the screen printing process.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--lilac relative">
            <span class="top-center-badge">
                <img src="../../../static/images/customisation/top-badge.png" alt="" />
            </span>
            <div class="cell small-12">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12 medium-8 medium-offset-2">
                        <p class="text-center">
                            <span class="button-text">Contact Us</span>
                        </p>
                    </div>
                </div>
                <form v-on:submit="sendContactForm">
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-3 medium-offset-2">
                            <input required v-model="contact.name" class="featured-input" type="text" placeholder="name">
                        </div>
                        <div class="cell small-12 medium-5">
                            <input required v-model="contact.message" class="featured-input" type="text" placeholder="Selection E.g Screen printing">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top--small">
                        <div class="cell small-12 medium-4 medium-offset-2">
                            <input required v-model="contact.email" class="featured-input" type="email" placeholder="Email address">
                        </div>
                        <div class="cell small-12 medium-4">
                            <input required v-model="contact.telephone" class="featured-input" type="text" placeholder="Telephone">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-8 medium-offset-2">
                            <p class="text-center">
                                <button class="button-text link">Send</button>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--dk-blue">
            <div class="cell small-12">
                <p class="text-center text-white">
                    <img width="50px" src="../../../static/images/customisation/tel.png" alt="" />
                    &nbsp;0116 467 0260&nbsp;
                    <img width="50px" src="../../../static/images/customisation/mail.png" alt="" />
                    &nbsp;info@customisedclothing.com&nbsp;
                    <img width="50px" src="../../../static/images/customisation/clock.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'ScreenPrinting',
    metaInfo() {
        return {
            title: 'Screen Printing Service | UK Based Production',
            titleTemplate: '%s - Customised Clothing',
            meta: [
                { description: 'Design your custom t-shirts, hoodies, hats and more with screen printing at customised clothing. Stand out with personalised style!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/screen-printing' },
            ],
        };
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                message: '',
                telephone: '',
            },
        };
    },
    methods: {
        sendContactForm(event) {
            event.preventDefault();
            axios.post('/Contacts/addContact.json', this.contact)
                .then(() => {
                    this.$router.push('/contact-thankyou');
                });
        },
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Screenprinting.vue